export default {
  free_items: '{{count}} Punkte = Gratis Artikel 🤩',
  button: {
    okay: 'Okay',
  },
};
